const fontFamily = '"Halcom", -apple-system, sans-serif';
const Typography = {
    fontFamily,
    fontSize: 16,
    htmlFontSize: 16,
    fontWeightBold: 800,
    fontWeightMedium: 700,
    fontWeightRegular: 600,
    h1: {
        fontFamily,
        fontSize: "1.75rem",
        fontWeight: 800,
        letterSpacing: 0
    },
    h2: {
        fontFamily,
        fontSize: "1.625rem",
        fontWeight: 800,
        letterSpacing: 0
    },
    h3: {
        fontFamily,
        fontSize: "1.5rem",
        fontWeight: 800,
        letterSpacing: 0
    },
    h4: {
        fontFamily,
        fontSize: "1.375rem",
        fontWeight: 800,
        letterSpacing: 0
    },
    h5: {
        fontFamily,
        fontSize: "1.25rem",
        fontWeight: 800,
        letterSpacing: 0
    },
    h6: {
        fontFamily,
        fontSize: "1.125rem",
        fontWeight: 800,
        letterSpacing: 0
    },
    subtitle1: {
        fontFamily,
        fontSize: "1rem",
        fontWeight: 700
    },
    subtitle2: {
        fontFamily,
        fontSize: "0.875rem",
        fontWeight: 700,
        letterSpacing: 0
    },
    caption: {
        fontFamily,
        fontSize: "0.75rem",
        fontWeight: 400,
        letterSpacing: 0,
        textTransform: "uppercase"
    },
    overline: {
        fontFamily,
        fontSize: "0.625rem",
        fontWeight: "normal"
    },
    buttonLarge: {
        fontFamily,
        fontSize: "1rem",
        fontWeight: "bolder",
        letterSpacing: "4%",
        textTransform: "uppercase"
    },
    buttonMedium: {
        fontFamily,
        fontSize: "0.875rem",
        fontWeight: 700,
        letterSpacing: "4%",
        textTransform: "uppercase"
    },
    buttonSmall: {
        fontFamily,
        fontSize: "0.75rem",
        fontWeight: "bolder",
        letterSpacing: "4%",
        textTransform: "uppercase"
    },
    body1: {
        fontFamily,
        fontSize: "1rem",
        fontWeight: 400,
        letterSpacing: 0
    },
    body2: {
        fontFamily,
        fontSize: "0.875rem",
        fontWeight: 400,
        letterSpacing: 0
    }
};
export default Typography;

//# sourceMappingURL=index.js.map